/**
 * Created by Denis Kuzin on 14 june 2024
 */

const ColorComponentView = cc.Node.extend({
    ctor: function (component, cellView) {
        this._super();

        this.component = component;
        this.cellView = cellView;

        this.setContentSize(cellView.getContentSize());
        this.setLocalZOrder(-1);

        const image = this.image = new cc.Sprite(this.getImage(this.component.cell));
        image.setPosition(this.width / 2, this.height / 2);
        this.addChild(image);
    },

    getImage: function (colorCell) {
        if (cleverapps.environment.isEditorScene() && this.cellView.getImage) {
            return this.cellView.getImage(colorCell);
        }

        const cellBundle = colorCell.bundleId() || "color_cells";

        if (colorCell.findComponent(ColorComponent).color === undefined) {
            return bundles[cellBundle].frames[`${cellBundle}_goal`];
        }

        let color = colorCell.findComponent(ColorComponent).color;

        if (this.cellView instanceof GoalColorCellView && cleverapps.config.name !== "adventure") {
            color = color.toUpperCase();
        }

        return bundles[cellBundle].frames[`${cellBundle}_${color}`];
    },

    updateImage: function (cell) {
        this.image.setSpriteFrame(this.getImage(cell));
    },

    hide: function () {
        this.image.setVisible(false);
    },

    show: function () {
        this.image.setVisible(true);
    },

    debugShowTypesList: function (list, action) {
        if (!cleverapps.config.debugMode) {
            return;
        }

        const styles = cleverapps.styles.ColorComponentView.debugButton;
        const combos = list.map((type) => new cleverapps.UI.Button({
            text: type.text,
            width: styles.width,
            height: styles.height,
            onClicked: function () {
                action(type.shapeName);
                this.debugTypesList.removeFromParent();
            }.bind(this)
        }));

        const layout = this.debugTypesList = new cleverapps.Layout(combos, {
            direction: cleverapps.UI.VERTICAL
        });

        const fieldView = Game.currentGame.field.onGetView();
        fieldView.addChild(layout);
        layout.setPosition(BaseCellView.alignInTheGrid(this.component.cell.x, this.component.cell.y));
        layout.replaceParentSamePlace(cleverapps.Scenes.GetMovingNode());
    }
});

cleverapps.styles.ColorComponentView = {
    debugButton: {
        width: 150,
        height: 50
    }
};
